/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/User/OrderStatus',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var viewModel = {};
    var findOrderform = {
        Fields: [
            {
                "Name": 'Order Number',
                "Field": '#order-number',
                "Param": 'orderNumber',
                "Type": 'Text'
            },
            {
                "Name": 'Email',
                "Field": '#order-email',
                "Param": 'email',
                "Type": 'Text',
                "Validators": [
                    {
                        "Type": 'Email'
                    }
                ]
            }
        ],
        Validate: true
    };    

    function showForm() {
        $(viewModel.orderDetailsSel).hide();
        $(viewModel.findOrderFormSel).show();
        Roc.Forms.clearFormInputs(viewModel.findOrderFormSel);
    }

    function showDetails() {
        $(viewModel.findOrderFormSel).hide();
        $(viewModel.orderDetailsSel).show();
    }

    /* Events */

    function checkAnotherOrderEvt() {
        $(document).on('click', '#btnCheckAnotherOrder', function () {
            showForm();
            return false;
        });
    }

    function checkOrderStatusEvt() {
        $(document).on('click', '#btnCheckOrderStatus', function (e) {
            if (!Roc.Validation.validateForm(findOrderform)) {
                return false;
            }

            var data = Roc.Forms.getFormValues(findOrderform);
            $.ajax({
                url: viewModel.apiUrl + '/api/order/status/',
                type: 'POST',
                data: JSON.stringify(data),
                dataType: 'json',
                contentType: 'application/json',
                beforeSend: function () {
                    Roc.Core.lockButton(e.currentTarget);
                },
                complete: function (xhr) {
                    Roc.Logger.info('OrderStatus -> checkOrderStatusEvt');
                    Roc.Logger.info(xhr);
                    var response = xhr.responseJSON || {};
                    if (xhr.status === 200) {
                        showDetails();
                        response.isLoggedIn = viewModel.isLoggedIn;

                        Roc.UI.template('orderStatus-Tmp', response).then(function (renderedTemplate) {
                            $(viewModel.orderDetailsSel).html(renderedTemplate);
                        });
                    } else {
                        Roc.UI.ajaxErrorPopup(xhr);
                    }

                    Roc.Core.releaseLockedButton(e.currentTarget);
                }
            });
            return false;
        });
    }

    function bindEvents() {
        checkOrderStatusEvt();
        checkAnotherOrderEvt();
    }
    
    function init(model) {
        viewModel = model;
        viewModel.form = findOrderform;
        viewModel.findOrderFormSel = '#checkOrderStatusForm';
        viewModel.orderDetailsSel = '#orderDetails';
        bindEvents();
    };

    var OrderStatus = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('OrderStatus.js Loaded:', OrderStatus);

    return OrderStatus;
});
